/* This Page need to be deleted once Cognito test pass through */
import { Component , OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, LoginData } from '../../services/auth.service';
import { RestService } from '../../services/rest.service';

@Component({
  selector: 'app-page-login',
  templateUrl: './page-login.component.html',
  styleUrls: ['./page-login.component.scss']
})
export class PageLoginComponent implements OnInit {

  public username = '';
  public password = '';
  public errorMessage = '';

  constructor(
     private auth: AuthService
    , private router: Router
    , private rest: RestService
  ) { }

  ngOnInit() {}

  loginUser(event) {
    event.preventDefault();
    this.rest.userInfo().subscribe((data: LoginData) => {
        this.auth.setLoginData(data);
        this.router.navigate(['/home'], {});
        return true;
      }, (err) => {
        this.errorMessage = 'Username or password is incorrect';
      });
  }

  setLogin(userType) {
  }
}
